import { useState } from "react";

type SubjectTabsProps = {
  tabs: { label: string; content: React.ReactNode }[];
  activeTab?: number;
  setActiveTab?: (index: number) => void;
};

const SubjectTabs = ({ tabs, activeTab: controlledTab, setActiveTab: setControlledTab }: SubjectTabsProps) => {
  const [internalTab, setInternalTab] = useState<number>(0);
  const activeTab = controlledTab ?? internalTab;
  const setActiveTab = setControlledTab ?? setInternalTab;

  const tabClass = (index: number) =>
    `myCustomTab ${activeTab === index ? "active" : ""}`;

  return (
    <>
      <div className="mySubjectTabContainer no-scrollbar">
        {tabs.map((tab, index) => (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            className={tabClass(index)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div className="tab-content">{tabs[activeTab]?.content}</div>
    </>
  );
};

export default SubjectTabs;